.list {
  height: 100%;
  overflow-y: auto;

  display: inline-block;
}

.listItem {
  padding-left: var(--dixa-size-spacer-200);
}
